import React from 'react';

const audience = [
    {
        tag: 'Primary Partner',
        name: 'E-commerce\n' + 'Entrepreneurs',
        description: 'You focus on selling - we handle everything behind the scenes. The perfect logistics partner\n' + 'for solo founders and growing online stores.',
        features: ['No upfront warehouse investment needed', 'Scale storage with your growth', 'Professional fulfillment from day one', 'COD collection and reconciliation'],
    },
    {
        tag: 'Corporate Partner',
        name: 'Business &\n' + 'Enterprises',
        description: 'Large-volume logistics, systematic handling, and dedicated account management for established companies with demanding supply chains.',
        features: ['Dedicated account manager', 'Custom SLA agreements', 'Bulk storage & dispatch', 'Reporting & analytics dashboard'],
    },
    {
        tag: 'Drop-Shipping & D2C',
        name: 'Dropshippers\n' + '& Brands',
        description: 'Whether you\'re drop-shipping or running a direct-to-consumer brand, we provide the infrastructure to fulfill reliably without the overhead.',
        features: ['Flexible per-order pricing', 'Fast turnaround on dispatch', 'Branded packaging options', 'Returns processed efficiently'],
    },
];

export default function Audience() {
    return (
        <section id="audience" className="bg-[#0a4abe] lg-custom:py-20 py-12" style={{ position: 'relative', overflow: 'hidden' }}>
            {/* background dots */}
            <div style={{
                position: 'absolute', inset: 0, opacity: 0.05,
                backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',
                backgroundSize: '28px 28px',
            }}/>

            <div className="dh-container" style={{ position: 'relative', zIndex: 1 }}>
                <div>
                    <div className="uppercase" style={{
                        display: 'inline-block', background: 'rgba(249,216,0,0.25)', color: '#f9d800',
                        borderRadius: '100px', padding: '3px 14px', fontSize: '12px',
                        fontFamily: "'Inter'", fontWeight: 500, marginBottom: '13px', letterSpacing: '0.5px',
                    }}>
                        who we serve
                    </div>
                    <h2 style={{
                        fontFamily: "'Bebas Neue'",
                        fontWeight: 900,
                        fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                        lineHeight: '0.95',
                        marginBottom: '1.5rem',
                        color: '#ffffff',
                    }}>
                        built for<br/>ambition
                    </h2>
                    <p style={{
                        color: 'rgba(255,255,255,0.7)',
                        fontSize: '17px',
                        fontFamily: "'Inter'",
                        lineHeight: 1.65,
                        marginBottom: '36px',
                        maxWidth: '380px'
                    }}>

                    </p>
                </div>

                <div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                        {audience.map(a => (
                            <div key={a.name} style={{
                                border: '1px solid rgba(255,255,255,0.25)',
                                borderRadius: '6px', padding: '2.5rem', position: 'relative', overflow: 'hidden', transition: 'border-color 0.3s',
                            }}
                                 onMouseEnter={e => {
                                     e.currentTarget.style.borderColor = 'rgba(249,216,0,0.50)';
                                     e.currentTarget.querySelector('.card-top-bar').style.transform = 'scaleX(1)';
                                 }}
                                 onMouseLeave={e => {
                                     e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)';
                                     e.currentTarget.querySelector('.card-top-bar').style.transform = 'scaleX(0)';
                                 }}
                            >
                                <div className="card-top-bar" style={{
                                    position: 'absolute', top: 0, left: 0, right: 0, height: '2px',
                                    background: 'rgba(249,216,0,1)',
                                    transform: 'scaleX(0)',
                                    transformOrigin: 'left',
                                    transition: 'transform 0.3s',
                                }}/>
                                <div style={{
                                    width: 'fit-content',
                                    background: 'rgba(249,216,0,0.25)',
                                    color: '#f9d800',
                                    borderRadius: '100px',
                                    padding: '3px 12px',
                                    fontSize: '10px',
                                    fontFamily: "'Inter'",
                                    fontWeight: 500,
                                    letterSpacing: '0.1px',
                                    textTransform: 'uppercase',
                                    marginBottom: '1rem',
                                }}>
                                    {a.tag}
                                </div>

                                <div style={{
                                    fontFamily: "'Bebas Neue'",
                                    fontSize: '2rem',
                                    color: '#ffffff',
                                    marginBottom: '1rem',
                                    lineHeight: '1.1',
                                    whiteSpace: 'pre-line'
                                }}>{a.name}</div>

                                <div style={{ fontFamily: "'Inter'", fontSize: '0.9rem', color: '#ffffff', lineHeight: '1.65' }}>{a.description}</div>

                                <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '1.2rem' }}>
                                    {a.features.map(f => (
                                        <li key={f} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                background: 'rgba(249,216,0,0.2)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0,
                                            }}>
                                                <span style={{
                                                    color: '#f9d800',
                                                    fontSize: '11px',
                                                    fontWeight: 700
                                                }}>✓</span>
                                            </div>
                                            <span style={{
                                                fontFamily: "'Inter'",
                                                fontSize: '14px',
                                                color: 'rgba(255,255,255,0.85)'
                                            }}>{f}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <style>{`
        @media (max-width: 768px) {
          .cov-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
        }
      `}</style>
        </section>
    );
}